// src/pages/PostJob.js
import React, { useEffect, useState } from "react";
import { ref, push, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { auth, db, storage } from "../utilities/firebaseConfig";
import Bookingnavbar from "../components/Bookingnavbar";
import backicon from "../assets/backicon.svg";
import { Autocomplete } from "@react-google-maps/api";
import Loader from "../components/Loader";

const PostJob = () => {
  const navigate = useNavigate();
  const [checkam, setCheckam] = useState("");
  const [services, setServices] = useState([]);
  const [locationError, setLocationError] = useState("");
  const [selecttday, setSelecttday] = useState(""); // time of day input
  const [address, setAddress] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [images, setImages] = useState([]);
  const [service, setService] = useState("");
  const [selectedServices, setSelectedServices] = useState("");
  const [jobData, setJobData] = useState({
    title: "",
    description: "",
    scheduledDate: "",
  });
  const [categories, setCategories] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(
    "Appliance Installation and Repairs"
  );
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Update jobData when checkam changes
  useEffect(() => {
    setJobData((prev) => ({ ...prev, serviceType: checkam }));
  }, [checkam]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false); // Hide modal after 3 seconds
    }, 3000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [show]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          let servicesList = [];
          Object.values(data).forEach((category) => {
            if (category.services) {
              Object.values(category.services).forEach((service) => {
                servicesList.push(service.name);
              });
            }
          });
          setServices(servicesList);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          setCategories(snapshot.val());
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update jobData with the new value on change
    setJobData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === "scheduledDate" && value) {
      const selectedDate = new Date(value); // Convert the selected date to a Date object
      const today = new Date(); // Get the current date

      // Normalize both dates to YYYY-MM-DD format (ignoring time)
      const formattedToday =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        today.getDate().toString().padStart(2, "0"); // 'YYYY-MM-DD' format
      const formattedSelectedDate =
        selectedDate.getFullYear() +
        "-" +
        (selectedDate.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        selectedDate.getDate().toString().padStart(2, "0"); // 'YYYY-MM-DD' format for selected date

      // Compare the date-only parts of the selected date and today's date
      if (formattedSelectedDate < formattedToday) {
        setShow(true);
        setErrorMessage("You can't pick a past date!");
        return;
      }
    }
  };

  // Get current location with high accuracy
  // const getCoordinates = () =>
  //   new Promise((resolve, reject) => {
  //     if (!navigator.geolocation) {
  //       return reject(
  //         new Error("Geolocation is not supported by your browser.")
  //       );
  //     }
  //     navigator.geolocation.getCurrentPosition(resolve, reject, {
  //       enableHighAccuracy: true,
  //       timeout: 10000,
  //       maximumAge: 0,
  //     });
  //   });

  // Handle job submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!jobData.title) {
      setShow(true);
      setErrorMessage("Please Enter your Job title.");
      return;
    }
    if (!jobData.description) {
      setShow(true);
      setErrorMessage("Please Enter your job description.");
      return;
    }

    if (!selecttday) {
      setShow(true);
      setErrorMessage(
        "Please select the time of day you want the job to be done."
      );
      return;
    }

    if (!address) {
      setShow(true);
      setErrorMessage("Please Enter your address.");
      return;
    }

    if (!jobData.scheduledDate) {
      setShow(true);
      setErrorMessage("Please Enter your task date.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      alert("User not authenticated.");
      return;
    }

    try {
      // Get current location
      setLoading(true);
      // const position = await getCoordinates();
      // const { latitude, longitude } = position.coords;

      // Retrieve the user's name from the database
      const userSnapshot = await get(ref(db, `users/${user.uid}`));
      const userName = userSnapshot.exists() ? userSnapshot.val().name : "";

      // Upload images to Firebase Storage and get URLs
      const uploadedImageURLs = await Promise.all(
        images.map(async (img, index) => {
          try {
            const imageRef = storageRef(
              storage,
              `jobImages/${user.uid}/${Date.now()}_${index}`
            );
            await uploadBytes(imageRef, img.file);
            return await getDownloadURL(imageRef);
          } catch (error) {
            console.error("Error uploading image:", error);
            return null; // Return null if upload fails
          }
        })
      ).then((urls) => urls.filter((url) => url !== null)); // Remove failed uploads

      // Build job object
      const newJob = {
        ...jobData,
        userId: user.uid,
        userName,
        status: "pending",
        createdAt: Date.now(),
        // location: { lat: latitude, lng: longitude },
        serviceType: selectedServices,
        timeOfDay: selecttday,
        address,
        images: uploadedImageURLs, // Store image URLs instead of previews
      };

      // Push job data to Firebase Realtime Database
      const jobRef = await push(ref(db, "jobs"), newJob);

      // Navigate to technician selection
      navigate(`/select-technician/${jobRef.key}`);
    } catch (error) {
      setShow(true);
      setErrorMessage("Error posting job:", error.message);
      setLocationError(
        "Unable to retrieve location. Please allow location access and try again."
      );
    } finally {
      setLoading(false); // ⬅️ Stop loader no matter what
    }
  };

  // Handle Google Places autocomplete
  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place?.formatted_address) {
        setAddress(place.formatted_address);
      }
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      id: file.name + "-" + file.lastModified,
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  // Delete an image
  const handleDeleteImage = (id) => {
    setImages((prevImages) =>
      prevImages.filter((img) => {
        if (img.id === id) {
          URL.revokeObjectURL(img.preview);
          return false;
        }
        return true;
      })
    );
  };

  // Cleanup object URLs when component unmounts
  useEffect(() => {
    return () => {
      images.forEach((img) => URL.revokeObjectURL(img.preview));
    };
  }, [images]);

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedServices([]); // Reset selected services when changing category
  };

  const handleServiceToggle = (serviceName) => {
    setSelectedServices((prevServices) => {
      if (prevServices.length > 0 && prevServices[0].name === serviceName) {
        return []; // If the selected service is clicked again, remove it
      } else {
        return [{ name: serviceName, price: 0 }]; // Replace with the new selection
      }
    });
  };

  return (
    <div>
      {loading && <Loader />}
      {show && (
        <div className='errormodal'>
          <h1 className='errortitle'>Error Message!!!</h1>

          <p className='errorpaa'>{errorMessage};</p>
        </div>
      )}
      <Bookingnavbar />
      <div className='bookingpagecnt'>
        <div className='thebiggap'></div>
        <button
          className='backicon'
          onClick={() => navigate("/client/dashboard")}
        >
          <img src={backicon} className='backiconimg' alt='' srcset='' />
        </button>
        <div className='thegap'></div>
        <h1 className='jdetailstitle'>Post a New Job</h1>
        <div className='thegap'></div>
        {locationError && <p style={{ color: "red" }}>{locationError}</p>}
        <form onSubmit={handleSubmit}>
          <div className='inputcnt'>
            <label htmlFor=''>In a few words. what do you need done?</label>
            <input
              type='text'
              name='title'
              placeholder='Job Title'
              value={jobData.title}
              onChange={handleChange}
            />
          </div>

          <div className='inputcnt'>
            <label htmlFor=''>What are the details?</label>
            <textarea
              name='description'
              placeholder='Job Description'
              value={jobData.description}
              onChange={handleChange}
            />
          </div>

          <div className='inputcnt'>
            <label>What Category does your task fall under?</label>
            <div className='category-buttons'>
              {Object.keys(categories).map((categoryName) => (
                <button
                  key={categoryName}
                  onClick={() => handleCategoryChange(categoryName)}
                  className={`category-btn ${
                    selectedCategory === categoryName ? "active" : ""
                  }`}
                >
                  {categoryName}
                </button>
              ))}
            </div>
          </div>
          <div className='thegap'></div>
          {/* Service Selection */}
          {selectedCategory && categories[selectedCategory]?.services && (
            <div>
              <label className='thealtinput'>What is the service type?</label>
              <div className='thespace'></div>
              <div className='service-options'>
                {Object.values(categories[selectedCategory].services).map(
                  (service) => (
                    <p
                      key={service.name}
                      className={`category-btn ${
                        selectedServices === service.name ? "active docl" : ""
                      }`}
                      onClick={() => setSelectedServices(service.name)}
                    >
                      {service.name}
                    </p>
                  )
                )}
              </div>
            </div>
          )}

          <div className='thebiggap'></div>
          <div className='inputcnt'>
            <label htmlFor=''>When do you need this done?</label>
            <input
              type='date'
              name='scheduledDate'
              value={jobData.scheduledDate}
              onChange={handleChange}
              onBlur={handleBlur} // Validate once user finishes typing
              min={new Date().toISOString().split("T")[0]} // Restrict past dates in the calendar
            />
          </div>

          <div className='inputcnt'>
            <label htmlFor=''>
              What time of the day do you want it to be done?
            </label>
            <div className='thegap'></div>
            <div className='thechoose'>
              <div
                onClick={() => setSelecttday("morning")}
                className={
                  selecttday === "morning" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Morning</p>{" "}
                <p className='seactn'>Before 10am</p>
              </div>
              <div
                onClick={() => setSelecttday("midday")}
                className={
                  selecttday === "midday" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Midday</p>{" "}
                <p className='seactn'>10am - 2pm</p>
              </div>
              <div
                onClick={() => setSelecttday("afternoon")}
                className={
                  selecttday === "afternoon"
                    ? "selectactive"
                    : "selectnotactive"
                }
              >
                <p className='seact'>Afternoon</p>{" "}
                <p className='seactn'>2pm - 6pm</p>
              </div>
              <div
                onClick={() => setSelecttday("evening")}
                className={
                  selecttday === "evening" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Evening</p>{" "}
                <p className='seactn'>After 6pm</p>
              </div>
            </div>
          </div>

          <div className='thegap'></div>
          <div className='inputcnt '>
            <label htmlFor='address' className='autocomplete-label'>
              Tell us where
            </label>
            <Autocomplete
              onLoad={(autocomplete) => setAutocomplete(autocomplete)}
              onPlaceChanged={handlePlaceChanged}
              options={{
                componentRestrictions: { country: "NG" }, // Restrict to Nigeria
              }}
            >
              <input
                type='text'
                name='address'
                placeholder='Enter your address'
                id='address'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className='autocomplete-input'
              />
            </Autocomplete>
          </div>
          <div className='inputcnt'>
            <label htmlFor='imageUpload'>Add images (optional)</label>
            <div className='theimageinputcnt'>
              <div className='custom-file-input'>
                <input
                  type='file'
                  id='imageUpload'
                  name='images'
                  multiple
                  accept='image/*'
                  onChange={handleFileChange}
                />
                <label htmlFor='imageUpload'>
                  <span className='upload-text'>+</span>
                </label>
              </div>
              <div className='preview-container'>
                {images.length > 0 ? (
                  images.map((img) => (
                    <div key={img.id} className='preview-item'>
                      <img
                        src={img.preview}
                        alt='Preview'
                        className='previewimg'
                      />
                      <button
                        onClick={() => handleDeleteImage(img.id)}
                        className='imgdeleteicon'
                      >
                        x
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No images uploaded.</p>
                )}
              </div>
            </div>
          </div>
          <div className='thebiggap'></div>
          <button className='thesigninbtn' type='submit'>
            Post Job
          </button>
        </form>
        <div className='thebiggap'></div>
      </div>
    </div>
  );
};

export default PostJob;
